import { useCallback } from 'react';
import { useCreateAdvisorIntroRequestMutation } from '../api';
import { useNotifications } from '@/features/notifications';
import { t } from 'i18next';
import ReactGA from 'react-ga4';

export type useOnCreateAdvisorIntroProps = {
  companyId: string;
  advisorId: string;
  advisorName: string;
};

export function useOnCreateAdvisorIntro({ companyId, advisorId, advisorName }: useOnCreateAdvisorIntroProps) {
  const [createAdvisorIntroRequest] = useCreateAdvisorIntroRequestMutation();
  const { add } = useNotifications();

  const createAdvisorIntro = useCallback(() => {
    createAdvisorIntroRequest({
      company_id: companyId,
      service_company_id: advisorId,
    })
      .unwrap()
      .then(() => {
        ReactGA.event({
          category: 'advisor_request_info_click',
          action: `Advisor intro requested`,
          label: `User has requested an intro for the following advisor "${advisorName}"`,
        });
        add({
          id: new Date().toString(),
          title: t('Intro successfully requested'),
          description: t("We'll connect you with the advisor within 24h."),
        });
      })
      .catch(() => {
        add({
          id: new Date().toString(),
          title: t('ERROR'),
          description: t('There was an error requesting the intro. Please try again later.'),
        });
      })
      .finally();
  }, [companyId, advisorId, createAdvisorIntroRequest, add]);

  return { createAdvisorIntro };
}
